/* eslint-disable */
export interface ActivityProgress {
    actualMaxHeartRate: number;
    calculatedMaxHeartRate: number;
    caloriesGoal: number;
    caloriesPercentage: number;
    caloriesProjectedPercentage: number;
    caloriesTotal: number;
    country: string;
    divisionName: string;
    email: string;
    endDate: number;
    firstName: string;
    goalId: GoalId;
    intensiveMinutesGoal: number;
    intensiveMinutesPercentage: number;
    intensiveMinutesProjectedPercentage: number;
    intensiveMinutesTotal: number;
    lastName: string;
    lastSync: number;
    ofPeriodPassedPercentage: number;
    period: PeriodType;
    persistenceGoal: number | null;
    persistencePercentage: number;
    persistenceTotal: number;
    startDate: number;
    stepsGoal: number;
    stepsPercentage: number;
    stepsProjectedPercentage: number;
    stepsTotal: number;
    totalPercentage: number;
    totalProjectedPercentage: number;
    userId: UserId;
}

export enum ActivityType {
    CALORIES = 'CALORIES',
    CARDIO_MINUTES = 'CARDIO_MINUTES',
    CUSTOM = 'CUSTOM',
    FAT_BURN_MINUTES = 'FAT_BURN_MINUTES',
    HEART_RATE = 'HEART_RATE',
    HEIGHT = 'HEIGHT',
    MAX_HEART_RATE = 'MAX_HEART_RATE',
    PEAK_MINUTES = 'PEAK_MINUTES',
    PEAK_SECONDS = 'PEAK_SECONDS',
    STEPS = 'STEPS',
    WEIGHT = 'WEIGHT',
    DISTANCE = 'DISTANCE',
    EXERCISE_MIN = 'EXERCISE_MIN',
    SLEEP_MIN = 'SLEEP_MIN',
}

export interface Annotation {
}

export interface AppleHealthActivityDto {
    activityType: ActivityType;
    diaryEntries: AppleHealthDiaryEntry[];
    endDate: number;
    startDate: number;
    timeZone: string;
}

export interface AppleHealthDiaryEntry {
    endDate: number;
    startDate: number;
    //timeOffset: number | null;
    value: number;
}

export interface ApplicationContext {
    applicationName: string;
    autowireCapableBeanFactory: AutowireCapableBeanFactory;
    beanDefinitionCount: number;
    beanDefinitionNames: string[];
    classLoader: ClassLoader;
    displayName: string;
    environment: Environment;
    id: string;
    parent: ApplicationContext;
    parentBeanFactory: BeanFactory;
    startupDate: number;
}

export interface AutowireCapableBeanFactory {
}

export interface BadgeDto {
    createdAt: number;
    goalId: GoalId;
    id: UserGoalResultId;
    voucher: string;
}

export interface BeanFactory {
}

export interface CalculateAllActiveGoalResults$Request {
    secret: string;
}

export interface CalculateAllActiveGoalResults$Response {
}

export interface CalculateDailyResults$Request {
    date: string;
    secret: string;
    userId: UserId;
}

export interface CalculateDailyResults$Response {
}

export interface CalculateDailyStatistics$Request {
    date: string;
    secret: string;
}

export interface CalculateDailyStatistics$Response {
}

export interface CalculateGoalResults$Request {
    goalId: GoalId;
    secret: string;
}

export interface CalculateGoalResults$Response {
}

export interface CalculateGoalResultsForAll$Request {
    goalId: GoalId;
    secret: string;
}

export interface CalculateGoalResultsForAll$Response {
}

export interface CalculateMonthlyResults$Request {
    month: string;
    secret: string;
    userId: UserId;
}

export interface CalculateMonthlyResults$Response {
}

export interface CalculateMonthlyStatistics$Request {
    month: string;
    secret: string;
}

export interface GetCompanyStatisticsByPeriod$Response {
  stats: Stats[]
}

export interface GetCompanyStatisticsByPeriod$Request {
    companyId: string;
    period: string;
    startDate: string;
    endDate: string;
}

export interface CalculateMonthlyStatistics$Response {
}

export interface CalculateUserGoalResult$Request {
    goalId: GoalId;
    secret: string;
    userId: UserId;
}

export interface CalculateUserGoalResult$Response {
}

export interface ChangePassword$Request {
    newPassword: SensitiveString;
    oldPassword: SensitiveString;
}

export interface ChangePassword$Response {
}

export interface ChangeUserLanguage$Request {
    lang: Lang;
}

export interface ChangeUserLanguage$Response {
}

export interface ClassLoader {
    definedPackages: Package[];
    name: string;
    parent: ClassLoader;
    registeredAsParallelCapable: boolean;
    unnamedModule: Module;
}

export interface CompanyCountriesDto {
    companyId: CompanyId;
    countries: string[];
}

export interface CompanyGoalResultsDto {
    activityProgress: ActivityProgress[];
    goalId: GoalId;
}

export type CompanyId = string;

export interface CompanyRankDto {
    companyId: CompanyId;
    companyName: string;
    participants: number;
    percentage: number;
    rank: number;
}

export interface CompanyStatistics {
    companyEnergyStatistics: CompanyStatistics$CompanyEnergyStatistics;
    companyIntensiveMinutesStatistics: CompanyStatistics$CompanyIntensiveMinutesStatistics;
    companyStepsStatistics: CompanyStatistics$CompanyStepsStatistics;
}

export interface CompanyStatistics$CompanyEnergyStatistics {
    bigMacs: number;
    totalKcal: number;
}

export interface CompanyStatistics$CompanyIntensiveMinutesStatistics {
    co2EmissionPrevented: number;
    totalMin: number;
}

export interface CompanyStatistics$CompanyStepsStatistics {
    roundsAroundTheWorld: number;
    totalDistance: number;
    totalSteps: number;
}

export interface CountryActivityProgress {
    caloriesTotal: number;
    country: string;
    intensiveMinutesTotal: number;
    participants: number;
    persistenceTotal: number;
    stepsTotal: number;
    totalPercentage: number;
}

export interface CreateGoal$Request {
    activityFormulaTarget: number | null;
    chatEnabled: boolean;
    collectiveGoal: number | null;
    companyId: CompanyId;
    customGoal: number | null;
    customName: string | null;
    customType: CustomType | null;
    customUnit: string | null;
    dailyPersistenceGoal: number | null;
    dailyStepsGoal: number | null;
    description: string;
    divisionId: DivisionId;
    endDate: number;
    hideCountriesTab: boolean;
    hideGroupsTab: boolean;
    hidePeopleTab: boolean;
    manualEntryEnabled: boolean;
    persistenceGoal: number | null;
    progressType: ProgressType;
    startDate: number;
    title: string;
    voucher: string;
    pointsLogic: any[] | null;
    roundDailyPoints: boolean;
    autoJoinEnabled: boolean;
    simpleManualEntry: boolean;
    maxManualEntryDays: number;
}

export interface CreateGoal$Response {
}

export interface CreateUser$Request {
    companyId: CompanyId;
    emails: string[];
    lang: Lang;
}

export interface CreateUser$Response {
    ids: UserId[];
}

export interface CreateUserOwnedCompany$Request {
    companyName: string;
}

export interface CreateUserOwnedCompany$Response {
    companyId: CompanyId;
    signUpCode: string;
}

export interface CustomEntry$Request {
    amount: number;
    customType: CustomType | null;
    date: string;
    goalId: GoalId;
    // TODO:
    pointsLogicId: string | null;
}

export interface CustomEntry$Response {
}

export enum CustomType {
    ACTIVITY_INDEX = 'ACTIVITY_INDEX',
    CUSTOM = 'CUSTOM',
    CYCLING_HR = 'CYCLING_HR',
    CYCLING_KM = 'CYCLING_KM',
    CYCLING_MI = 'CYCLING_MI',
    CYCLING_MIN = 'CYCLING_MIN',
    DISTANCE_KM = 'DISTANCE_KM',
    DISTANCE_MI = 'DISTANCE_MI',
    EXERCISE_HR = 'EXERCISE_HR',
    EXERCISE_MIN = 'EXERCISE_MIN',
    MINDFULNESS_HR = 'MINDFULNESS_HR',
    MINDFULNESS_MIN = 'MINDFULNESS_MIN',
    OUTDOOR_TIME_HR = 'OUTDOOR_TIME_HR',
    OUTDOOR_TIME_MIN = 'OUTDOOR_TIME_MIN',
    PLANKING_HR = 'PLANKING_HR',
    PLANKING_MIN = 'PLANKING_MIN',
    RUNNING_HR = 'RUNNING_HR',
    RUNNING_KM = 'RUNNING_KM',
    RUNNING_MI = 'RUNNING_MI',
    RUNNING_MIN = 'RUNNING_MIN',
    SLEEPING_HR = 'SLEEPING_HR',
    SLEEP_HR = 'SLEEP_HR',
    SLEEP_MIN = 'SLEEP_MIN',
    SWIMMING_HR = 'SWIMMING_HR',
    SWIMMING_KM = 'SWIMMING_KM',
    SWIMMING_M = 'SWIMMING_M',
    SWIMMING_MI = 'SWIMMING_MI',
    SWIMMING_MIN = 'SWIMMING_MIN',
    SWIMMING_YD = 'SWIMMING_YD',
    WALKING_HR = 'WALKING_HR',
    WALKING_KM = 'WALKING_KM',
    WALKING_MEETING_MEETINGS = 'WALKING_MEETING_MEETINGS',
    WALKING_MEETING_MIN = 'WALKING_MEETING_MIN',
    WALKING_MI = 'WALKING_MI',
    WALKING_MIN = 'WALKING_MIN',
    WATER_DRINKING_CUP = 'WATER_DRINKING_CUP',
    WATER_DRINKING_GLASS = 'WATER_DRINKING_GLASS',
    WATER_DRINKING_ML = 'WATER_DRINKING_ML',
    WATER_DRINKING_OZ = 'WATER_DRINKING_OZ',
    YOGA_HR = 'YOGA_HR',
    YOGA_MIN = 'YOGA_MIN',
    OTHER_MIN = 'OTHER_MIN',

    STEPS = 'STEPS',
    CALORIES = 'CALORIES',
    INTENSIVE_MINUTES = 'INTENSIVE_MINUTES',

    POINTS = 'POINTS',

    CUSTOM_SIMPLE = 'CUSTOM_SIMPLE',
    CUSTOM_WITH_AMOUNT = 'CUSTOM_WITH_AMOUNT',

    // New manual entry challenges.
    BOOK_READING_MIN = 'BOOK_READING_MIN',
    BOOK_READING_BOOKS = 'BOOK_READING_BOOKS',
    BOOK_READING_PAGES = 'BOOK_READING_PAGES',

    ENCOURAGING_PEOPLE = 'ENCOURAGING_PEOPLE',
    CAR_FREE_DAYS = 'CAR_FREE_DAYS',
    ALCOHOL_ABSTINENCE = 'ALCOHOL_ABSTINENCE',
    SQUATTING = 'SQUATTING',
    CONTRAST_SHOWER_SEC = 'CONTRAST_SHOWER_SEC',
    FINANCE_TRACKING = 'FINANCE_TRACKING',
    HEALTHY_COOKING_MEALS = 'HEALTHY_COOKING_MEALS',
    DEEP_BREATHING_MIN = 'DEEP_BREATHING_MIN',
    DAILY_JOURNALING = 'DAILY_JOURNALING',
    PUSH_UPS = 'PUSH_UPS',
    PULL_UPS = 'PULL_UPS',
    CREATIVE_ARTS_MIN = 'CREATIVE_ARTS_MIN',
    SOCIALIZING_WITH_FRIENDS_MIN = 'SOCIALIZING_WITH_FRIENDS_MIN',
    COLD_PLUNGE_SEC = 'COLD_PLUNGE_SEC',
    INTERMITTENT_FASTING_HR = 'INTERMITTENT_FASTING_HR',
    GRATITUDE_JOURNALING = 'GRATITUDE_JOURNALING',
    LANGUAGE_LEARNING_MIN = 'LANGUAGE_LEARNING_MIN',
    HOBBY_DEVELOPMENT_MIN = 'HOBBY_DEVELOPMENT_MIN',
    NATURAL_LIGHT_EXPOSURE = 'NATURAL_LIGHT_EXPOSURE',
    SMOKING_CESSATION = 'SMOKING_CESSATION',
    PHONE_FREE_TIME_HR = 'PHONE_FREE_TIME_HR',
    //CAFFEINE_REDUCTION = 'CAFFEINE_REDUCTION',
    SCREEN_FREE_MEALS = 'SCREEN_FREE_MEALS',
    DAILY_FLOSSING = 'DAILY_FLOSSING',
    //STRESS_LEVEL_MONITORING = 'STRESS_LEVEL_MONITORING',
    //MOOD_TRACKING = 'MOOD_TRACKING',
}

export interface DeleteGoal$Request {
    goalId: GoalId;
}

export interface DeleteGoal$Response {
}

export interface DeleteUser$Request {
    companyId: CompanyId;
    userId: UserId;
}

export interface DeleteUser$Response {
}

export interface DeleteUserFromGarmin$Response {
}

export interface DeleteUserOwnedCompany$Request {
    companyId: CompanyId;
}

export interface DeleteUserOwnedCompany$Response {
    companyName: string;
}

export interface DivisionActivityProgress {
    caloriesTotal: number;
    country: string;
    divisionId: DivisionId;
    divisionName: string;
    intensiveMinutesTotal: number;
    participants: number;
    persistenceTotal: number;
    stepsTotal: number;
    totalPercentage: number;
}

export interface DivisionDto {
    companyId: CompanyId;
    id: DivisionId;
    name: string;
}

export type DivisionId = string | null;

export interface EndUserThirdPartyIntegration$Request {
}

export interface EndUserThirdPartyIntegration$Response {
}

export interface Environment {
    activeProfiles: string[];
    defaultProfiles: string[];
}

export interface ExportGoalResults$Request {
    goalId: GoalId;
}

export interface ExportGoalResults$Response {
    fileContent: number[];
    fileMediaType: string;
    fileName: string;
}

export interface FinalizeGarminIntegration$Request {
    oauthToken: string;
    oauthVerifierValue: string;
    redirectUrl: string;
}

export interface FinalizeGarminIntegration$Response {
    redirectView: RedirectView;
}

export enum Gender {
    FEMALE = 'FEMALE',
    MALE = 'MALE',
}

export interface GetAllCompanyGoals$Request {
}

export interface GetAllCompanyGoals$Response {
    goalDtos: GoalDto[];
}

export interface GetAllSpecificCompanyGoals$Request {
    companyId: CompanyId;
}

export interface GetAllSpecificCompanyGoals$Response {
    goalDtos: GoalDto[];
}

export interface GetAllUserGoals$Request {
    companyId: CompanyId;
}

export interface GetAllUserGoals$Response {
    achievedGoals: UserGoal[];
    currentGoals: UserGoal[];
    unAchievedGoals: UserGoal[];
}

export interface GetAppleHealthSyncStart$Request {
}

export interface GetAppleHealthSyncStart$Response {
    lastSyncDatePerActivity: LastSyncDatePerActivityDto;
}

export interface GetAppleHealthSyncTimes$Request {
    forceLongSync: boolean;
}

export interface GetGoogleFitAndroidSyncTimes$Request {
    forceLongSync: boolean;
}

export interface GetAppleHealthSyncStartTimes$Response {
    lastSyncDatePerActivity: LastSyncDatePerActivityDto;
}

export interface GetAppleHealthSyncStartAndEndDate$Request {
}

export interface GetAppleHealthSyncStartAndEndDate$Response {
    endDate: number;
    startDate: number;
}

export interface GetChatUserToken$Request {
}

export interface GetChatUserToken$Response {
    userToken: string;
}

export interface GetCompanyActivityProgressInPeriod$Request {
    companyId: CompanyId;
    endDate: number;
    progressType: ProgressType;
    projectedPercentageAt: number;
    startDate: number;
}

export interface GetCompanyActivityProgressInPeriod$Response {
    activityProgress: { [key: string ]: ActivityProgress;};
}

export interface GetCompanyCountries$Request {
}

export interface GetCompanyCountries$Response {
    countries: string[];
}

export interface GetCompanyCurrentGoal$Request {
    companyId: CompanyId;
}

export interface GetCompanyCurrentGoal$Response {
    goalDto: GoalDto;
}

export interface GetCompanyCurrentGoalCountryProgress$Request {
    companyId: CompanyId;
}

export interface GetCompanyCurrentGoalCountryProgress$Response {
    countryActivityProgress: CountryActivityProgress[];
    periodPercentage: number;
}

export interface GetCompanyCurrentGoalDivisionProgress$Request {
    companyId: CompanyId;
    groupView: GroupView;
}

export interface GetCompanyCurrentGoalDivisionProgress$Response {
    divisionActivityProgress: DivisionActivityProgress[];
    periodPercentage: number;
}

export interface GetCompanyCurrentGoalProgress$Request {
    companyId: CompanyId;
}

export interface GetCompanyCurrentGoalProgress$Response {
    activityProgress: { [key: string ]: ActivityProgress;};
}

export interface GetCompanyCurrentGoalProgressFiltered$Request {
    companyId: CompanyId;
    countries: string[];
    divisionIds: DivisionId[];
}

export interface GetCompanyCurrentGoalProgressFiltered$Response {
    activityProgress: { [key: string ]: ActivityProgress;};
}

export interface GetCompanyDivisions$Request {
}

export interface GetCompanyDivisions$Response {
    divisionDtos: DivisionDto[];
}

export interface GetCompanyGoalsInPeriod$Request {
    companyId: CompanyId;
    endDate: number;
    startDate: number;
}

export interface GetCompanyGoalsInPeriod$Response {
    goalDtos: GoalDto[];
}

export interface GetCompanyGoalsProgress$Request {
    companyId: CompanyId;
}

export interface GetCompanyGoalsProgress$Response {
    companyGoalsResults: CompanyGoalResultsDto[];
}

export interface GetCompanyRanking$Request {
}

export interface GetCompanyRanking$Response {
    companyRanking: CompanyRankDto[];
    periodPercentage: number;
}

export interface GetCompanyRankingFiltered$Request {
    companyId: CompanyId;
    month: string;
}

export interface GetCompanyRankingFiltered$Response {
    companyIsExcludedFromRanking: boolean;
    companyRanking: CompanyRankDto[];
    periodPercentage: number;
}

export interface GetCompanySignUpCode$Request {
    companyId: CompanyId;
}

export interface GetCompanySignUpCode$Response {
    signUpCode: string;
}

export interface GetCompanyEmployees$Request {
    companyId: CompanyId;
}

export interface GetCompanyEmployees$Response {
    employees: string;
}


export interface SetCompanyEmployees$Request {
    companyId: CompanyId;
    employees: number;
    month: string;
}

export interface SetCompanyEmployees$Response {
}

export interface GetCompanyStatistics$Request {
}

export interface GetCompanyStatistics$Response {
    companyStatistics: CompanyStatistics;
    showTable: boolean;
}

export interface GetCompanyUsers$Request {
}

export interface GetCompanyUsers$Response {
    companyUsers: UserProfileDto[];
}

export interface GetGoalCountryProgress$Request {
    goalId: GoalId;
    sum: boolean;
}

export interface GetGoalCountryProgress$Response {
    countryActivityProgress: CountryActivityProgress[];
    periodPercentage: number;
}

export interface GetGoalGroupProgress$Request {
    goalId: GoalId;
    groupView: GroupView;
    sum: boolean;
}

export interface GetGoalGroupProgress$Response {
    divisionActivityProgress: DivisionActivityProgress[];
    periodPercentage: number;
}

export interface GetGoalIndividualProgress$Request {
    countries: string[];
    divisionIds: DivisionId[];
    goalId: GoalId;
    skipJoin: boolean;
    token: string;
}

export interface GetChallengesWithProgress$Request {
    version: string;
}

export interface GetGoalIndividualProgress$Response {
    activityProgress: { [key: string ]: ActivityProgress;};
}

export interface GetGoalsWithProgress$Request {
}

export interface GetGoalsWithProgress$Response {
    goals: GoalWithProgress[];
}

export interface GetGoogleFitAndroidSyncStart$Request {
}

export interface GetGoogleFitAndroidSyncStart$Response {
    lastSyncDatePerActivity: LastSyncDatePerActivityDto;
}

export interface GetLeaderboardCountries$Request {
    goalId: GoalId;
    sum: boolean;
    token: string;
}

export interface GetLeaderboardCountries$Response {
    companyCountries: CompanyCountriesDto[];
    countryActivityProgress: CountryActivityProgress[];
    divisionDtos: DivisionDto[];
    goals: GoalWithProgress[];
    periodPercentage: number;
}

export interface GetLeaderboardGroups$Request {
    goalId: GoalId;
    groupView: GroupView;
    sum: boolean;
    token: string;
}

export interface GetLeaderboardGroups$Response {
    companyCountries: CompanyCountriesDto[];
    divisionActivityProgress: DivisionActivityProgress[];
    divisionDtos: DivisionDto[];
    goals: GoalWithProgress[];
    periodPercentage: number;
}

export interface GetLeaderboardPeople$Request {
    countries: string[];
    divisionIds: DivisionId[];
    goalId: GoalId;
    skipJoin: boolean;
    token: string;
}

export interface GetLeaderboardPeople$Response {
    activityProgress: { [key: string ]: ActivityProgress;};
    companyCountries: CompanyCountriesDto[];
    divisionDtos: DivisionDto[];
    goals: GoalWithProgress[];
}

export interface GetNextSyncStartDateForActivity$Request {
    activityType: ActivityType;
}

export interface GetNextSyncStartDateForActivity$Response {
    lastSyncDate: number;
}

export interface GetSpecificCompanyStatistics$Request {
    companyId: CompanyId;
}

export interface GetSpecificCompanyStatistics$Response {
    companyStatistics: CompanyStatistics;
    showTable: boolean;
}

export interface GetSpecificCompanyUsers$Request {
    companyId: CompanyId;
}

export interface GetSpecificCompanyUsers$Response {
    companyUsers: UserDto[];
}

export interface GetUserActivityProgressInPeriod$Request {
    companyId: CompanyId;
    endDate: number;
    progressType: ProgressType;
    projectedPercentageAt: number;
    startDate: number;
    userId: UserId;
}

export interface GetUserActivityProgressInPeriod$Response {
    activityProgress: ActivityProgress;
}

export interface GetUserBadges$Request {
    userId: UserId;
}

export interface GetUserBadges$Response {
    badges: BadgeDto[];
}

export interface GetUserCompanyCountries$Request {
}

export interface GetUserCompanyCountries$Response {
    companyCountries: CompanyCountriesDto[];
}

export interface GetUserCurrentGoalProgress$Request {
    companyId: CompanyId;
}

export interface GetUserCurrentGoalProgress$Response {
    activityProgress: { [key: string ]: ActivityProgress;};
}

export interface GetUserCustomProgress$Request {
    customType: CustomType | null;
    endDate: string;
    goalId: GoalId;
    startDate: string;
    pointsLogicId: string | null;
}

export interface GetUserDailyDiaryProgress$Request {
    customType: CustomType;
    endDate: string;
    startDate: string;
}

export interface GetUserCustomProgress$Response {
    customDiary: UserCustomDailyProgress[];
}

export interface GetUserDailyDiaryProgress$Response {
    dailyDiary: UserDailyDiaryProgress[];
}

export interface GetUserDetailedProgress$Request {
    endDate: number;
    startDate: number;
    userId: UserId;
}

export interface GetUserDetailedProgress$Response {
    progressResults: UserDailyProgress[];
}

export interface GetUserGoalProgress$Request {
    goalId: GoalId;
}

export interface GetUserGoalProgress$Response {
    activityProgress: { [key: string ]: ActivityProgress;};
}

export interface GetUserGoals$Request {
    companyId: CompanyId;
}

export interface GetUserGoals$Response {
    currentGoals: GoalRow[];
    pastGoals: GoalRowWithUserProgress[];
}

export interface GetUserProfile$Request {
}

export interface GetUserProfile$Response {
    profileDto: ProfileDto;
}

export interface GoalDto {
    achievedCount: number;
    activityFormulaTarget: number | null;
    avgProgress: number;
    chatEnabled: boolean;
    collectiveGoal: number | null;
    collectivePercentage: number;
    collectiveTotal: number;
    companyId: CompanyId;
    customGoal: number | null;
    customName: string | null;
    customType: CustomType | null;
    customUnit: string | null;
    dailyPersistenceGoal: number | null;
    dailyStepsGoal: number | null;
    description: string;
    divisionId: DivisionId;
    endDate: number;
    hideCountriesTab: boolean;
    hideGroupsTab: boolean;
    hidePeopleTab: boolean;
    id: GoalId;
    ownerUserId: UserId;
    manualEntryEnabled: boolean;
    participantsCount: number;
    persistenceGoal: number | null;
    progressType: ProgressType;
    startDate: number;
    stepsGoal: number;
    title: string;
    voucher: string;
}

export type GoalId = string;

export interface GoalRow {
    achievedCount: number;
    activityFormulaTarget: number | null;
    avgProgress: number;
    chatEnabled: boolean;
    collectiveGoal: number | null;
    collectivePercentage: number;
    collectiveTotal: number;
    companyId: CompanyId;
    createdAt: number;
    customGoal: number | null;
    customName: string | null;
    customType: CustomType | null;
    customUnit: string | null;
    dailyPersistenceGoal: number | null;
    dailyStepsGoal: number | null;
    description: string;
    divisionId: DivisionId;
    emailsSent: boolean;
    endDate: number;
    hideCountriesTab: boolean;
    hideGroupsTab: boolean;
    hidePeopleTab: boolean;
    id: GoalId;
    manualEntryEnabled: boolean;
    ownerUserId: UserId;
    participantsCount: number;
    persistenceGoal: number | null;
    progressType: ProgressType;
    startDate: number;
    title: string;
    token: string;
    updatedAt: number;
    voucher: string;
}

export interface GoalRowWithUserProgress {
    achievedCount: number;
    activityFormulaTarget: number | null;
    avgProgress: number;
    companyId: CompanyId;
    createdAt: number;
    dailyStepsGoal: number | null;
    divisionId: DivisionId;
    emailsSent: boolean;
    endDate: number;
    id: GoalId;
    ownerUserId: UserId;
    participantsCount: number;
    progressType: ProgressType;
    startDate: number;
    totalPercentage: number;
    updatedAt: number;
    voucher: string;
}

export interface GoalWithProgress {
    achievedCount: number;
    activityFormulaTarget: number | null;
    avgProgress: number;
    chatEnabled: boolean;
    collectiveGoal: number | null;
    collectivePercentage: number;
    collectiveTotal: number;
    companyId: CompanyId;
    companyLogo: string;
    companyName: string;
    customGoal: number | null;
    customName: string | null;
    customType: CustomType | null;
    customUnit: string | null;
    dailyPersistenceGoal: number | null;
    dailyStepsGoal: number | null;
    description: string;
    divisionId: DivisionId;
    endDate: number;
    hideCountriesTab: boolean;
    hideGroupsTab: boolean;
    hidePeopleTab: boolean;
    id: GoalId;
    manualEntryEnabled: boolean;
    ownerUserId: UserId;
    participantsCount: number;
    participating: boolean;
    persistenceGoal: number | null;
    progressType: ProgressType;
    startDate: number;
    stepsGoal: number;
    title: string;
    totalPercentage: number;
    voucher: string;
    illustrationUrl: string;
    illustrationColor: string;
    logoUrl: string;
    pointsLogic: string;
    roundDailyPoints: boolean;
    autoJoinEnabled: boolean;
    simpleManualEntry: boolean;
    maxManualEntryDays: number;
}

export interface GoogleSignIn$Request {
    authorizationCode: string;
    lang: string;
    nonce: string;
    redirectUri: string;
    signUpCode: string;
}

export interface GoogleSignIn$Response {
    lang: string;
    message: string;
}

export enum GroupView {
    COUNTRIES_MERGED = 'COUNTRIES_MERGED',
    COUNTRIES_SEPARATED = 'COUNTRIES_SEPARATED',
    ONLY_MY_COUNTRY = 'ONLY_MY_COUNTRY',
    ONLY_MY_GROUP = 'ONLY_MY_GROUP',
}

export interface JoinChat$Request {
    goalId: GoalId;
}

export interface JoinChat$Response {
}

export interface JoinCompany$Request {
    signUpCode: string;
    userId: UserId;
}

export interface JoinCompany$Response {
    userCompanyId: UserCompanyId;
}

export interface JoinGoal$Request {
    goalId: GoalId;
}

export interface JoinGoal$Response {
}

export enum Lang {
  AR = 'AR',
  BG = 'BG',
  BS = 'BS',
  CS = 'CS',
  DA = 'DA',
  DE = 'DE',
  EL = 'EL',
  EN = 'EN',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FR = 'FR',
  HR = 'HR',
  HU = 'HU',
  ID = 'ID',
  IT = 'IT',
  JA = 'JA',
  KO = 'KO',
  LT = 'LT',
  LV = 'LV',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RU = 'RU',
  SK = 'SK',
  SL = 'SL',
  SQ = 'SQ',
  SR = 'SR',
  SV = 'SV',
  TH = 'TH',
  TR = 'TR',
  UK = 'UK',
  VI = 'VI',
  ZH_HANS = 'ZH_HANS',
}

export interface LastSyncDatePerActivityDto {
    CALORIES: number;
    HEART_RATE: number;
    HEIGHT: number;
    STEPS: number;
    WEIGHT: number;
}

export interface LeaveCompany$Request {
    companyId: CompanyId;
}

export interface LeaveCompany$Response {
    companyName: string;
}

export interface LeaveGoal$Request {
    goalId: GoalId;
}

export interface LeaveGoal$Response {
}

export interface LogString$Request {
    string: string;
}

export interface LogString$Response {
}

export interface Login$Request {
    email: string;
    password: SensitiveString;
}

export interface Login$Response {
    lang: Lang;
    sessionId: string;
}

export interface Logout$Request {
}

export interface Logout$Response {
}

export interface Module {
    annotations: Annotation[];
    classLoader: ClassLoader;
    declaredAnnotations: Annotation[];
    descriptor: ModuleDescriptor;
    layer: ModuleLayer;
    name: string;
    named: boolean;
    packages: string[];
}

export interface ModuleDescriptor {
    automatic: boolean;
    open: boolean;
}

export interface ModuleLayer {
}

export interface MutableSession {
    httpSessionId: string;
    lastModified: number;
    resetPasswordInProgress: boolean;
    role: Role;
    roles: { [key: string ]: Role[];};
    userId: UserId;
}

export enum OnboardingStatus {
    ACTIVITY_DATA = 'ACTIVITY_DATA',
    ACTIVITY_SYNC_IN_PROGRESS = 'ACTIVITY_SYNC_IN_PROGRESS',
    DONE = 'DONE',
    INTEGRATION = 'INTEGRATION',
    PROFILE_DATA = 'PROFILE_DATA',
    PROFILE_SYNC_IN_PROGRESS = 'PROFILE_SYNC_IN_PROGRESS',
}

export interface Package {
    annotations: Annotation[];
    declaredAnnotations: Annotation[];
    implementationTitle: string;
    implementationVendor: string;
    implementationVersion: string;
    name: string;
    sealed: boolean;
    specificationTitle: string;
    specificationVendor: string;
    specificationVersion: string;
}

export enum PeriodType {
    DAY = 'DAY',
    MONTH = 'MONTH',
    WEEK = 'WEEK',
}

export interface ProfileDto {
    appleId: string;
    companyName: string;
    country: string;
    dateOfBirth: string;
    divisionId: DivisionId;
    divisionName: string;
    firstName: string;
    gender: Gender;
    googleId: string;
    height: number;
    integrationError: string;
    integrationOk: boolean;
    lastName: string;
    lastSynced: number;
    newsletterSubscriber: boolean;
    onboardingStatus: OnboardingStatus;
    passwordSet: boolean;
    serviceProvider: ServiceProvider;
    timeZone: string;
    units: Units;
    weight: number;
}

export enum ProgressType {
    ACTIVITY = 'ACTIVITY',
    ALL = 'ALL',
    CALORIES = 'CALORIES',
    COLLECTIVE_CALORIES = 'COLLECTIVE_CALORIES',
    COLLECTIVE_CUSTOM = 'COLLECTIVE_CUSTOM',
    COLLECTIVE_INTENSIVE_MINUTES = 'COLLECTIVE_INTENSIVE_MINUTES',
    COLLECTIVE_STEPS = 'COLLECTIVE_STEPS',
    COLLECTIVE_POINTS = 'COLLECTIVE_POINTS',
    CUSTOM = 'CUSTOM',
    DISTANCE = 'DISTANCE',
    FORMULA = 'FORMULA',
    INTENSIVE_MINUTES = 'INTENSIVE_MINUTES',
    PERSISTENCE_ALL = 'PERSISTENCE_ALL',
    PERSISTENCE_CALORIES = 'PERSISTENCE_CALORIES',
    PERSISTENCE_CUSTOM = 'PERSISTENCE_CUSTOM',
    PERSISTENCE_CUSTOM_BINARY = 'PERSISTENCE_CUSTOM_BINARY',
    PERSISTENCE_INTENSIVE_MINUTES = 'PERSISTENCE_INTENSIVE_MINUTES',
    PERSISTENCE_STEPS = 'PERSISTENCE_STEPS',
    PERSISTENCE_POINTS = 'PERSISTENCE_POINTS',
    POINTS = 'POINTS',
    STEPS = 'STEPS',
}

export interface RedirectView {
    applicationContext: ApplicationContext;
    attributesMap: { [key: string ]: any;};
    beanName: string;
    contentType: string;
    exposePathVariables: boolean;
    hosts: string[];
    propagateQueryProperties: boolean;
    redirectView: boolean;
    requestContextAttribute: string;
    staticAttributes: { [key: string ]: any;};
    url: string;
}

export interface RegisterUser$Request {
    password: SensitiveString;
}

export interface RegisterUser$Response {
}

export interface ResetPassword$Request {
    newPassword: SensitiveString;
}

export interface ResetPassword$Response {
}

export enum Role {
    ADMIN = 'ADMIN',
    ANONYMOUS = 'ANONYMOUS',
    USER = 'USER',
    AUTHENTICATED = 'AUTHENTICATED',
}

export interface SaveGarminOauthRequestToken$Request {
    redirectUrl: string;
}

export interface SaveGarminOauthRequestToken$Response {
    redirectView: RedirectView;
}

export interface SendMail$Request {
    companyName: string;
    email: string;
    name: string;
    phone: string;
    userMessage: string;
}

export interface SendMail$Response {
}

export type SensitiveString = string;

export enum ServiceProvider {
    APPLE_HEALTH = 'APPLE_HEALTH',
    CUSTOM = 'CUSTOM',
    FITBIT = 'FITBIT',
    GARMIN = 'GARMIN',
    GOOGLE_FIT = 'GOOGLE_FIT',
    GOOGLE_FIT_ANDROID = 'GOOGLE_FIT_ANDROID',
    HUAWEI = 'HUAWEI',
    MANUAL = 'MANUAL',
    POLAR = 'POLAR',
    SUUNTO = 'SUUNTO',
    YUMUUV = 'YUMUUV',
}

export interface SetAppleHealthIntegration$Request {
}

export interface SetAppleHealthIntegration$Response {
}

export interface SetNoIntegration$Request {
}

export interface SetNoIntegration$Response {
}

export interface SetOnboardingStatusToActivityData$Request {
}

export interface SetOnboardingStatusToActivityData$Response {
}

export interface SetOnboardingStatusToIntegration$Response {
}

export interface SetSyncEnabled$Request {
    secret: string;
    syncEnabled: boolean;
}

export interface SetSyncEnabled$Response {
}

export interface SetUserCountry$Request {
    companyId: CompanyId;
    country: string;
    userId: UserId;
}

export interface SetUserCountry$Response {
}

export interface SetUserDivision$Request {
    companyId: CompanyId;
    divisionId: DivisionId;
    userId: UserId;
}

export interface SetUserDivision$Response {
}

export interface SetUserThirdPartyIntegration$Request {
    authorizationCode: string;
    redirectUrl: string;
    serviceProvider: ServiceProvider;
}

export interface SetUserThirdPartyIntegration$Response {
}

export interface SignUp$Request {
    companyCode: string;
    email: string;
    lang: string;
    password: SensitiveString;
}

export interface SignUp$Response {
    message: string;
}

export interface Stats {
  type: string;
  result: number;
  startDate: string;
  endDate: string;
  data: string;
  updatedAt: number;
}

export interface StartResetPassword$Request {
    email: string;
}

export interface StartResetPassword$Response {
}

export interface StepsCampaign$Request {
}

export interface StepsCampaign$Response {
    companies: number;
    participants: number;
    steps: number;
}

export interface SyncUserThirdPartyData$Request {
}

export interface SyncUserThirdPartyData$Response {
}

export interface SyncUsersInCompanyThirdPartyData$Request {
    companyId: CompanyId;
    secret: string;
}

export interface SyncUsersInCompanyThirdPartyData$Response {
}

export interface ToggleCompanyExcludedFromRanking$Request {
    companyId: CompanyId;
}

export interface ToggleCompanyExcludedFromRanking$Response {
    newExcludedFromRanking: boolean;
}

export interface TogglePublicStatus$Request {
}

export interface TogglePublicStatus$Response {
    newStatus: boolean;
}

export interface ToggleUserStatus$Request {
    companyId: CompanyId;
    userId: UserId;
}

export interface ToggleUserStatus$Response {
    newStatus: boolean;
}

export enum Units {
    IMPERIAL = 'IMPERIAL',
    METRIC = 'METRIC',
}

export interface UpdateActivityData$Request {
    dateOfBirth: string;
    gender: Gender;
    height: number;
    units: Units;
    weight: number;
}

export interface UpdateActivityData$Response {
}

export interface UpdateGoal$Request {
    activityFormulaTarget: number | null;
    chatEnabled: boolean;
    collectiveGoal: number | null;
    companyId: CompanyId;
    customGoal: number | null;
    customName: string | null;
    customType: CustomType | null;
    customUnit: string | null;
    dailyPersistenceGoal: number | null;
    dailyStepsGoal: number | null;
    description: string;
    endDate: number;
    goalId: GoalId;
    hideCountriesTab: boolean;
    hideGroupsTab: boolean;
    hidePeopleTab: boolean;
    manualEntryEnabled: boolean;
    persistenceGoal: number | null;
    progressType: ProgressType;
    startDate: number;
    title: string;
    voucher: string;
    pointsLogic: any[] | null;
    roundDailyPoints: boolean;
    autoJoinEnabled: boolean;
    simpleManualEntry: boolean;
    maxManualEntryDays: number;
}

export interface UpdateGoal$Response {
}

export interface UpdateProfileData$Request {
    country: string;
    divisionId: DivisionId;
    firstName: string;
    lastName: string;
    newsletterSubscriber: boolean;
    timeZone: string;
}

export interface UpdateProfileData$Response {
}

export interface UpdateUserDateOfBirth$Request {
    dateOfBirth: string;
}

export interface UpdateUserDateOfBirth$Response {
}

export interface UpdateUserGender$Request {
    gender: Gender;
}

export interface UpdateUserGender$Response {
}

export interface UpdateUserProfile$Request {
    country: string;
    dateOfBirth: string;
    divisionId: DivisionId;
    firstName: string;
    gender: Gender;
    height: number;
    lastName: string;
    newsletterSubscriber: boolean;
    onlyProfileUpdate: boolean;
    timeZone: string;
    units: Units;
    weight: number;
}

export interface UpdateUserProfile$Response {
}

export interface UploadAllAppleHealthActivities$Request {
    appleHealthActivities: AppleHealthActivityDto[];
    timeZone: string;
}

export interface UploadAllAppleHealthActivities$Response {
}

export interface UploadAllGoogleFitActivities$Request {
    googleFitActivities: AppleHealthActivityDto[];
    timeZone: string;
}

export interface UploadAllGoogleFitActivities$Response {
}

export interface UploadAppleHealthActivity$Request {
    activityType: ActivityType;
    diaryEntries: AppleHealthDiaryEntry[];
    endDate: number;
    startDate: number;
}

export interface UploadAppleHealthActivity$Response {
}

export interface UploadAppleHealthStepsAndCalories$Request {
    activityType: ActivityType;
    diaryEntries: AppleHealthDiaryEntry[];
    endDate: number;
    startDate: number;
}

export interface UploadAppleHealthStepsAndCalories$Response {
}

export interface UserCompanyDto {
    active: boolean;
    companyId: CompanyId;
    companyName: string;
    country: string;
    countryRequired: boolean;
    createdAt: number;
    divisionId: DivisionId;
    divisionName: string;
    divisionRequired: boolean;
    employees: number;
    hideRankingView: boolean;
    hideStatisticsView: boolean;
    reportRequired: boolean;
    reportRequiredForUsers: boolean;
    id: UserCompanyId;
    ownerCompanyId: CompanyId;
    ownerUserId: UserId;
    publicGoalsEnabled: boolean;
    scope: string;
    userGoalsEnabled: boolean;
    userId: UserId;
    userLimit: number;
    brandLogoUrl: string;
    plan: string;
    trialStartDate: string;
    trialEndDate: string;
    startAt: string;
    paidUntil: string;
    salesperson: string;
    salespersonEmail: string;
}

export type UserCompanyId = string;

export interface UserCompanyRolesDto {
    companyId: CompanyId;
    roles: Role[];
    userId: UserId;
}

export interface UserCustomDailyProgress {
    date: string;
    value: number;
}

export interface UserDailyDiaryProgress {
    date: string;
    integrationValue: number;
    manualValue: number;
    sum: number;
}

export interface UserDailyProgress {
    caloriesGoal: number;
    caloriesPercentage: number;
    caloriesTotal: number;
    date: string;
    distanceKm: number;
    intensiveMinutesGoal: number;
    intensiveMinutesPercentage: number;
    intensiveMinutesTotal: number;
    stepsGoal: number;
    stepsPercentage: number;
    stepsTotal: number;
    totalPercentage: number;
    integrationTotalPercentage: number;
}

export interface UserDto {
    active: boolean;
    appleId: string;
    companyId: CompanyId;
    companyName: string;
    country: string;
    createdAt: number;
    dateOfBirth: string;
    divisionId: DivisionId;
    divisionName: string;
    email: string;
    firstName: string;
    gender: Gender;
    googleId: string;
    height: number;
    integrationError: string;
    lang: Lang;
    lastName: string;
    lastSync: number;
    newsletterSubscriber: boolean;
    onboardingStatus: OnboardingStatus;
    role: Role;
    serviceProvider: string;
    timeZone: string;
    units: Units;
    userId: UserId;
    weight: number;
}

export interface UserProfileDto {
    active: boolean;
    appleId: string;
    country: string;
    createdAt: number;
    dateOfBirth: string;
    email: string;
    firstName: string;
    gender: Gender;
    googleId: string;
    height: number;
    integrationError: string;
    lang: Lang;
    lastName: string;
    lastSync: number;
    newsletterSubscriber: boolean;
    onboardingStatus: OnboardingStatus;
    //role: Role;
    serviceProvider: ServiceProvider;
    timeZone: string;
    units: Units;
    userId: UserId;
    weight: number;
    passwordSet: boolean;
}

export interface UserGoal {
    activityProgress: ActivityProgress;
    goalDto: GoalDto;
}

export type UserGoalResultId = string;

export type UserId = string;

export interface WhoAmI$Request {
}

export interface WhoAmI$Response {
    authenticated: boolean;
    resetPasswordInProgress: boolean;
    userCompanies: UserCompanyDto[];
    userCompanyRoles: UserCompanyRolesDto[];
    userDto: UserProfileDto;
}

export interface GetWhoAmI$Request {
  platform: string;
  osVersion: string;
  appVersion: string;
}

export interface GetWhoAmI$Response {
    authenticated: boolean;
    resetPasswordInProgress: boolean;
    userCompanies: UserCompanyDto[];
    userCompanyRoles: UserCompanyRolesDto[];
    userDto: UserProfileDto;
}

export interface DeleteUserFromGarmin$Request { userId: string; }
